module.exports = __webpack_public_path__ + "img/menu-takeaway.5dcf05f0.svg";